import Route from '@ember/routing/route';
import { instrumentRoutePerformance } from '@sentry/ember';

class BacklogInitiativesInitiativeKnowledgeBaseListRoute extends Route {
  queryParams = {
    search: {
      refreshModel: false,
    },
  };
  model() {
    return this.modelFor('backlog.initiatives.initiative');
  }
}

export default instrumentRoutePerformance(
  BacklogInitiativesInitiativeKnowledgeBaseListRoute,
);
